import { Link, useLocation } from 'react-router-dom'
import { List, Map } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import { useLivabilityPaths } from '../utils/paths'

export function ApartmentViewSwitcher({ className }: { className?: string }) {
  const { pathname } = useLocation()
  const paths = useLivabilityPaths()
  const isMap = pathname.includes('/apartments-map')
  const isList = /\/apartments$/.test(pathname)

  if (!isMap && !isList) return null

  return (
    <div
      className={cn(
        'inline-flex rounded-full border border-ink/[0.06] bg-ink/[0.03] p-1',
        className
      )}
      role="group"
      aria-label="Zobrazenie bytov"
    >
      <Button
        asChild
        size="sm"
        variant={isList ? 'default' : 'ghost'}
        className="rounded-full px-4 gap-2"
      >
        <Link to={paths.list}>
          <List className="h-4 w-4" />
          Zoznam
        </Link>
      </Button>
      <Button
        asChild
        size="sm"
        variant={isMap ? 'default' : 'ghost'}
        className="rounded-full px-4 gap-2"
      >
        <Link to={paths.map}>
          <Map className="h-4 w-4" />
          Mapa
        </Link>
      </Button>
    </div>
  )
}
